export default "mutation insertAccreditation ($accreditation: AccreditationInput!) {\n  insertAccreditation (accreditation: $accreditation)\n}\n";